// Cross-step state for the /advertise funnel (Agents, Sellers/Boost, Builders).
// Persisted to sessionStorage so refresh/back-forward keep answers, but nothing
// survives the tab closing — this is lead/PII data, not a saved preference.
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

const emptyAgents = {
  plan: '',
  firstName: '', lastName: '', email: '', company: '', phone: '', zip: '', mlsId: '',
  activeListings: '', markets: [], timeline: '', competitors: [],
  slotIso: '', slotLabel: '',
  consent: false,
};

const emptySellers = {
  address: '', city: '', state: '', zip: '', lat: null, lng: null,
  matchedListingId: null, matchedListing: null,
  beds: '', baths: '', sqft: '', listPrice: '',
  role: '', mlsId: '', brokerage: '', onMls: '',
  firstName: '', lastName: '', email: '', phone: '', contactPref: 'email',
  quoteId: '', quoteAmount: null,
  sessionId: '', orderStatus: '',
  consent: false,
};

const emptyBuilders = {
  companyName: '', city: '', state: '', website: '', communityCount: '',
  marketsServed: [], homeTypes: [], annualVolume: '',
  firstName: '', lastName: '', email: '', phone: '', zip: '', title: '',
  slotIso: '', slotLabel: '',
  consent: false,
};

export const useAdvertise = create(
  persist(
    (set, get) => ({
      agents: { ...emptyAgents },
      sellers: { ...emptySellers },
      builders: { ...emptyBuilders },

      setField: (track, patch) =>
        set((state) => ({ [track]: { ...state[track], ...patch } })),

      reset: (track) =>
        set(() => ({
          [track]: track === 'agents' ? { ...emptyAgents } : track === 'sellers' ? { ...emptySellers } : { ...emptyBuilders },
        })),

      resetAll: () => set({ agents: { ...emptyAgents }, sellers: { ...emptySellers }, builders: { ...emptyBuilders } }),

      get: (track) => get()[track],
    }),
    {
      name: 'ch_advertise_v1',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({ agents: state.agents, sellers: state.sellers, builders: state.builders }),
    }
  )
);
